import React from 'react'
import MainHeading from './MainHeading'
import SubHeading from './SubHeading'

/* Title consists of both main and sub heading*/
const Heading = ({ mainHeading, subHeading, classes = '', mainClasses, subClasses }) => {
  return (
    <div className={'border-gray-200 inline-block ' + classes}>
      <MainHeading mainHeading={mainHeading} classes={mainClasses} />
      {subHeading && <SubHeading subHeading={subHeading} classes={subClasses} />}
    </div>
  )
}

export default Heading
